import { render } from "./search.vue?vue&type=template&id=1cc1aae3"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=1cc1aae3&lang=less"
script.render = render

export default script